module.exports = __webpack_public_path__ + "static/media/brooch_2.11699397.jpg";